/**
 * Core Swiper bundle with just what we use by default.
 */
import Swiper, { EffectFade } from 'swiper';

window.GPPageTransitionsSwiper = {
	Swiper,
	EffectFade,
};
